import { useEffect, useState } from "react"
import { styled } from "@mui/material/styles"

type CountdownTimerProps = {
  targetTimestamp: number;
  onCountdownEnd: () => void;
}

export default function CountdownTimer(props: CountdownTimerProps) {
  const { targetTimestamp, onCountdownEnd } = props

  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetTimestamp))

  useEffect(() => {
    const intervalId = setInterval(() => {
      const remaining = calculateTimeLeft(targetTimestamp)
      setTimeLeft(remaining)

      if (remaining.total <= 0) {
        clearInterval(intervalId)
        onCountdownEnd()
      }
    }, 1000)

    return () => clearInterval(intervalId)
  }, [targetTimestamp])

  function calculateTimeLeft(target: number) {
    const now = Date.now()
    const difference = target - now

    if (difference <= 0) {
      return { total: 0, hours: 0, minutes: 0, seconds: 0 }
    }

    return {
      total: difference,
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    }
  }

  function formatTime(time: number) {
    return time.toString().padStart(2, "0")
  }

  return (
    <Container>
      {timeLeft.total > 0 ? (
        <span>
          {timeLeft.hours > 0 && `${timeLeft.hours}:`}
          {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
        </span>
      ) : null}
    </Container>
  )
}

const Container = styled("div")(({ theme }) => ({
  "& span": {
    fontFamily: "VazirmatnFD, serif !important"
  }
}))
